module.exports = __webpack_public_path__ + "img/type_right_5.b8d9e0e7.png";